import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseRequisitionLine, PurchaseRequisitionLineCreate, PurchaseRequisitionLineFilter } from '../data/purchaseRequisitionLine';

export function createPurchaseRequisitionLineService(client: AxiosInstance) {
  return createCrudService<PurchaseRequisitionLine, PurchaseRequisitionLineCreate, PurchaseRequisitionLineFilter>(
    client,
    '/purchase/PurchaseRequisitionLine',
    'id',
  );
}

export type PurchaseRequisitionLineService = CrudService<PurchaseRequisitionLine, PurchaseRequisitionLineCreate, PurchaseRequisitionLineFilter>;
